import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "dataTable" }
const _hoisted_4 = { style: {"margin-bottom":"8px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Filter = _resolveComponent("Filter")!
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Filter, {
        filter: this.filter,
        statusList: this.statusList,
        onAddFilterStatus: this.addFilterStatus,
        onClearFilter: this.clearFilter,
        onRemoveFilterStatus: this.removeFilterStatus,
        onSearch: _ctx.search,
        onSetDevisId: this.setDevisId,
        onSetDevisPubliDateFrom: this.setDevisPubliDateFrom,
        onSetDevisPubliDateTo: this.setDevisPubliDateTo,
        onSetNumFactures: this.setNumFactures,
        onSetNumero: this.setNumero,
        onStatusToggleSelectAll: this.statusToggleSelectAll
      }, null, 8, ["filter", "statusList", "onAddFilterStatus", "onClearFilter", "onRemoveFilterStatus", "onSearch", "onSetDevisId", "onSetDevisPubliDateFrom", "onSetDevisPubliDateTo", "onSetNumFactures", "onSetNumero", "onStatusToggleSelectAll"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", null, _toDisplayString(this.count) + " " + _toDisplayString(_ctx.$t('devis.dataTable.title', this.count > 1 ? 2 : 1)), 1),
        (!_ctx.isExportDisabled)
          ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
              key: 0,
              imgUrl: _ctx.iconeXls,
              title: _ctx.$t('list.export'),
              onClick: _ctx.exportXls
            }, null, 8, ["imgUrl", "title", "onClick"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.tableData.length === 0 && _ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoaderComponent, {
            key: 0,
            class: "loader"
          }))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            ref: "content",
            class: "datatable-container",
            onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
          }, [
            _createVNode(_component_DataTable, {
              count: +_ctx.count,
              isLoading: _ctx.isLoading,
              tableData: this.tableData,
              tableHeader: this.tableHeader,
              onSelect: _ctx.goToPage,
              onSort: _ctx.doSort
            }, null, 8, ["count", "isLoading", "tableData", "tableHeader", "onSelect", "onSort"])
          ], 544))
    ]),
    (_ctx.isExportXlsLoading)
      ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}